import {useState, SetStateAction} from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Drawer, {DrawerProps} from '@mui/material/Drawer';

import {useBoolean} from 'src/hooks/use-boolean';

import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import FileThumbnail from 'src/components/file-thumbnail';
import {fData} from 'src/utils/format-number';
import {Card, CardContent, Chip, Dialog, DialogContent} from '@mui/material';

// ----------------------------------------------------------------------
interface FileToUpload {
  ids: string;
  fileData: string; // Assuming base64-encoded string of the file's data
  fileName: string; // The name of the file
  fileType: string; // The MIME type of the file// The MIME type of the file
  fileError: string;
}
interface WrittenData {
  id: string;
  isFavorited: boolean;
  title: string;
  description: string;
  date: string;
  attachmentName?: FileToUpload[];
}
type Props = DrawerProps & {
  item: WrittenData;
  // eslint-disable-next-line react/boolean-prop-naming
  favorited?: boolean;
  //
  onFavorite?: VoidFunction;
  onCopyLink?: VoidFunction;
  //
  onClose: VoidFunction;
  onDelete: VoidFunction;
};

export default function RenderNoteDialog({
  item,
  open,
  favorited,
  //
  onFavorite,
  onCopyLink,
  onClose,
  onDelete,
  ...other
}: Props) {
  const {title, description, date, attachmentName} = item;
  const properties = useBoolean(true);
  const toggleTags = useBoolean(true);
  const datatags = useBoolean(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState('');

  // Handler to open dialog and set selected file data
  const handleClickOpen = (fileData: SetStateAction<string>) => {
    setSelectedFileData(fileData);
    setOpenDialog(true);
  };

  // Handler to close dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  console.log('item', item);
  const renderTags = (
    <Stack spacing={1.5}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{typography: 'subtitle2'}}>
        Description
        <IconButton size="small" onClick={toggleTags.onToggle}>
          <Iconify
            icon={
              toggleTags.value
                ? 'eva:arrow-ios-upward-fill'
                : 'eva:arrow-ios-downward-fill'
            }
          />
        </IconButton>
      </Stack>
      {toggleTags.value && (
        <Stack
          sx={{
            border: '1px dashed rgba(145, 158, 171, 0.2)',
            minHeight: '35vh',
            padding: 1,
            backgroundColor: 'rgba(145, 158, 171, 0.08)'
          }}>
          {description}
        </Stack>
      )}
    </Stack>
  );
  const renderProperties = (
    <Stack spacing={1.5}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{typography: 'subtitle2'}}>
        Properties
        <IconButton size="small" onClick={properties.onToggle}>
          <Iconify
            icon={
              properties.value
                ? 'eva:arrow-ios-upward-fill'
                : 'eva:arrow-ios-downward-fill'
            }
          />
        </IconButton>
      </Stack>

      {properties.value && (
        <>
          <Stack
            direction="row"
            sx={{typography: 'caption', textTransform: 'capitalize'}}>
            <Box
              component="span"
              sx={{width: 80, color: 'text.secondary', mr: 2}}>
              Created At
            </Box>
            {date}
          </Stack>
        </>
      )}
    </Stack>
  );

  const renderdatas = (
    <Stack spacing={1.5}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{typography: 'subtitle2'}}>
        Attachements
        <IconButton size="small" onClick={datatags.onToggle}>
          <Iconify
            icon={
              datatags.value
                ? 'eva:arrow-ios-upward-fill'
                : 'eva:arrow-ios-downward-fill'
            }
          />
        </IconButton>
      </Stack>
      {datatags.value && attachmentName ? (
        <Stack>
          {Object.keys(attachmentName).length > 0 ? (
            Object.values(attachmentName).map(file => (
              <Stack key={file.ids} direction="row" alignItems="center">
                <Card
                  variant="outlined"
                  sx={{marginBottom: 0.5, cursor: 'pointer'}}>
                  <CardContent
                    sx={{
                      padding: 1,
                      display: 'flex',
                      alignItems: 'center',
                      pb: '8px !important'
                    }}
                    onClick={() => handleClickOpen(file.fileData)}>
                    <FileThumbnail
                      file={file.fileData}
                      sx={{width: 40, height: 40}}
                      imgSx={{borderRadius: 1}}
                    />
                    <Typography variant="body2" noWrap sx={{mx: 2}}>
                      {file.fileName}
                    </Typography>
                    <Chip
                      label={fData(
                        typeof file.fileData === 'string'
                          ? file.fileData.length
                          : (file.fileData as ArrayBuffer).byteLength
                      )}
                    />
                  </CardContent>
                </Card>
              </Stack>
            ))
          ) : (
            <Typography>No attachments available.</Typography>
          )}
        </Stack>
      ) : null}
    </Stack>
  );
  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        anchor="right"
        slotProps={{
          backdrop: {invisible: true}
        }}
        PaperProps={{
          sx: {width: '42vh', height: '94vh', marginTop: '6.3vh'}
        }}
        {...other}>
        <Scrollbar sx={{height: 1}}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{p: 2.5}}>
            <Typography variant="h6"> Notes</Typography>

            <Checkbox
              color="warning"
              icon={<Iconify icon="eva:star-outline" />}
              checkedIcon={<Iconify icon="eva:star-fill" />}
              checked={favorited}
              onChange={onFavorite}
            />
          </Stack>

          <Stack
            spacing={2.5}
            justifyContent="center"
            sx={{
              p: 2.5,
              bgcolor: 'background.neutral'
            }}>
            {/* <FileThumbnail
              imageView
              file={type === 'folder' ? type : url}
              sx={{width: 64, height: 64}}
              imgSx={{borderRadius: 1}}
            /> */}

            <Typography variant="subtitle1" sx={{wordBreak: 'break-all'}}>
              {title}
            </Typography>

            <Divider sx={{borderStyle: 'dashed'}} />

            {renderTags}
            {renderProperties}
            {renderdatas}
          </Stack>
        </Scrollbar>

        <Box sx={{p: 2.5}}>
          <Button
            fullWidth
            variant="soft"
            color="error"
            size="large"
            startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
            onClick={onDelete}>
            Delete
          </Button>
        </Box>
      </Drawer>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogContent>
          <img
            src={selectedFileData}
            alt="Selected"
            style={{maxWidth: '100%', maxHeight: '60vh', padding: '2vh'}}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
